import { limit as limitFirebase, orderBy, where } from "firebase/firestore";
import { getRevendasAssociadas, isPlatformOwner } from "../../config/auth";
import { Collection, WhereField } from '../../shared/constants';
import { isNullOrEmpty } from '../../shared/utils';
import { getAllDocsByQueries } from './collectionBaseWorker';

export const getLastLogs = async ({ limit }) => {
    if (isPlatformOwner()) {
        return await getAllDocsByQueries({
            collection: Collection.ANALYTICS,
            queries: [
                orderBy(WhereField.CREATED_AT, "desc"),
                limitFirebase(limit ?? 5)
            ]
        })
    } else {
        const associatedRessales = getRevendasAssociadas()
        return await getAllDocsByQueries({
            collection: Collection.ANALYTICS,
            queries: [
                where(WhereField.REVENDAID, "in", associatedRessales.map(e => e.value)),
                orderBy(WhereField.CREATED_AT, "desc"),
                limitFirebase(limit ?? 5)
            ]
        })
    }
}

export const getAnalyticsLogs = async ({ estacionamentoId, clienteId, type, screen, limit }) => {
    const items = await getAllDocsByQueries({
        collection: Collection.ANALYTICS,
        queries: [
            !isNullOrEmpty(estacionamentoId) && where(WhereField.PARKID, "==", estacionamentoId),
            !isNullOrEmpty(clienteId) && where(WhereField.CLIENTEID, "==", clienteId),
            !isNullOrEmpty(type) && where(WhereField.TYPE, "==", type),
            !isNullOrEmpty(screen) && where(WhereField.SCREEN, "==", screen),
            orderBy(WhereField.CREATED_AT, "desc"),
            limitFirebase(limit)
        ]
    })
    return items
}